import { render, staticRenderFns } from "./EditIntellectGuide.vue?vue&type=template&id=4227e564&scoped=true"
import script from "./EditIntellectGuide.vue?vue&type=script&lang=js"
export * from "./EditIntellectGuide.vue?vue&type=script&lang=js"
import style0 from "./EditIntellectGuide.vue?vue&type=style&index=0&id=4227e564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4227e564",
  null
  
)

export default component.exports